var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-field" }, [
    _c("label", { staticClass: "label-hr" }, [_vm._v(_vm._s(_vm.field.title))]),
    _vm._v("\n    " + _vm._s(_vm.field.min_column) + "\n    "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.value,
          expression: "value"
        }
      ],
      attrs: { type: "range", min: _vm.minColumn, max: _vm.maxColumn },
      domProps: { value: _vm.value },
      on: {
        __r: function($event) {
          _vm.value = $event.target.value
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }